import React, { useState } from 'react';
import { Button, Form, Col, Row, Badge, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ThemeModal from './ThemeModal';
import ThemeItem from './ThemeItem';
import themesService from '../services/theme.service';
import projectThemesService from '../services/project_report/project_themes.service';
import ImmutableUnderReviewFormControl from '../util/reviewEditControls/ImmutableUnderReviewFormControl';
import { Loader } from '../util/Loader';
const ThemeSection = _ref => {
  let {
    report,
    setReport,
    claimGroup,
    pageAccess,
    isUnderReview,
    onAdd,
    onRemove,
    labelColSpan = 4,
    displayOnly = false
  } = _ref;
  const [themes, setThemes, fetchThemes] = themesService.useFetchAll({
    companyId: claimGroup.company_id
  });
  const [selectedTheme, setSelectedTheme] = useState(null);
  const {
    t
  } = useTranslation();
  const [modalShow, setModalShow] = useState(false);
  const handleChange = e => {
    if (+e.target.value === 0) {
      setModalShow(true);
    } else {
      setSelectedTheme(+e.target.value);
    }
  };
  const submit = async () => {
    if (onAdd) {
      return onAdd(report, report.themes.find(theme => theme.id === selectedTheme));
    }
    const newProjectTheme = await projectThemesService.create(report.id, {
      theme_id: selectedTheme
    });
    setSelectedTheme(null);
    setReport({
      ...report,
      project_theme: newProjectTheme
    });
  };
  const handleDelete = async id => {
    await projectThemesService.delete(report.id, id);
    setReport({
      ...report,
      project_theme: null
    });
  };
  const handleCreateTheme = async theme => {
    const newTheme = await themesService.create(claimGroup.company_id, theme);
    setReport({
      ...report,
      themes: [...report.themes, newTheme]
    });
  };
  if ([null, undefined].includes(themes)) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, pageAccess.canEditProjectDetails && /*#__PURE__*/React.createElement(ThemeModal, {
    title: 'Create Theme',
    onHide: () => setModalShow(false),
    show: modalShow,
    onSubmit: handleCreateTheme
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    className: "ThemeSection-FormLabel",
    column: true,
    md: labelColSpan
  }, t('themes')), !displayOnly && !report.project_theme && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Col, {
    md: 4
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "select",
    size: "md",
    disabled: report.project_theme || !pageAccess.canEditProjectDetails || isUnderReview,
    name: "themeId",
    onChange: e => handleChange(e),
    type: "text",
    placeholder: "Small text",
    value: selectedTheme || ''
  }, /*#__PURE__*/React.createElement("option", {
    value: ''
  }), pageAccess.canCreateNewTheme && /*#__PURE__*/React.createElement("option", {
    value: "0"
  }, t('create_new')), themes
  //.filter(bu => report.project_business_units.every(pbu => pbu.business_unit.id !== bu.id))
  .map(c => {
    return /*#__PURE__*/React.createElement("option", {
      key: c.id,
      value: c.id
    }, c.name);
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, pageAccess.canEditProjectDetails && /*#__PURE__*/React.createElement(Button, {
    disabled: !selectedTheme,
    variant: "link",
    onClick: submit
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add'))))), report.project_theme && /*#__PURE__*/React.createElement(ThemeItem, {
    project_theme: report.project_theme,
    handleDelete: onRemove || handleDelete,
    pageAccess: pageAccess
  }));
};
export default ThemeSection;